// extracted by mini-css-extract-plugin
module.exports = {"darkModeSlider":"Settings_darkModeSlider__36H8n"};